import React from 'react';
import { Box, useTheme } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const ThemedIcon = () => {
  const theme = useTheme();
  const fillColor = theme?.colors?.brand?.dark?.text || 'white';
  const strokeColor = theme?.colors?.brand?.light?.text || 'orange';

  // Define keyframes for stroke-draw animation
  const draw = keyframes`
    from {
      stroke-dashoffset: 1000;
    }
    to {
      stroke-dashoffset: 0;
    }
  `;

  return (
    <Box display="flex" justifyContent="center"   width="100%"  mt="0" pt="0">
      <svg
        viewBox="0 20 160 140"
        xmlns="http://www.w3.org/2000/svg"
        width="200"
        height="200"
        style={{ display: 'block' }}
      >
        <g transform="translate(0, -20)"> 
        <path
          d="M38.155 140.475L48.988 62.1108L92.869 67.0568L111.437 91.0118L103.396 148.121L38.155 140.475ZM84.013 94.0018L88.827 71.8068L54.046 68.3068L44.192 135.457L98.335 142.084L104.877 96.8088L84.013 94.0018ZM59.771 123.595C59.394 123.099 56.05 120.299 55.421 119.433C64.32 109.522 86.05 109.645 92.085 122.757C91.08 123.128 86.59 125.072 85.71 125.567C83.192 118.25 68.445 115.942 59.771 123.595ZM76.503 96.4988L72.837 99.2588L67.322 92.6168L59.815 96.6468L56.786 91.5778L63.615 88.1508L59.089 82.6988L64.589 79.0188L68.979 85.4578L76.798 81.5328L79.154 86.2638L72.107 90.0468L76.503 96.4988Z"
          fill="none"
          stroke={strokeColor}
          strokeWidth="2"
          strokeDasharray="1000"
          strokeDashoffset="0"
          style={{
            animation: `${draw} 2.5s ease forwards`,
          }}
        />
        </g>
      </svg>
    </Box>
  );
};

export default ThemedIcon;
